import { logErrorWrapper } from '../logWrapper';

import { init as initLibrary } from './library';
import { getProps, type StrevdaProps } from './props';

export const initStrevda = (): void => {
  try {
    const props: StrevdaProps = getProps();
    if (!props.enabled) return;
    initLibrary(props.strevdaRuntimeProps, props.containers);
  } catch (err: unknown) {
    logErrorWrapper(err as Error, {
      message: 'Failed to initialise strevda runtime',
      component: 'strevda-runtime',
    });
  }
};
